import {useEffect, useMemo, useState} from "react";
import isEmpty from "lodash/isEmpty";
import useLocalStorageModule from "use-local-storage";
import {usePricingContext} from "../context/pricingContext/context";
const useLocalStorage = useLocalStorageModule.default ?? useLocalStorageModule;

export const useHandleOs = (planType) => {
  const [selectedOSCache, setSelectedOSCache] = useLocalStorage(
    "selectedOSCache",
    undefined
  );
  const [selectedOS, setSelectedOS] = useState(selectedOSCache);
  const {baremetalClusterPricing, baremetalPricing, cloudInstancePricing} =
    usePricingContext();

  const osOptions = useMemo(() => {
    const {operating_systems: baremetalClusterOS = []} = baremetalClusterPricing || {};
    const {operating_systems: baremetalOS = []} = baremetalPricing || {};
    const {operating_systems: cloudInstanceOS = []} = cloudInstancePricing || {};
    let options = {
      "Baremetal-Cluster": baremetalClusterOS,
      Baremetal: baremetalOS,
      "Cloud-Instances": cloudInstanceOS,
      Custom: undefined,
    };
    return options[planType];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planType]);

  useEffect(() => {
    if (isEmpty(osOptions)) {
      setSelectedOS(undefined);
      setSelectedOSCache(undefined);
    } else {
      // check if selectedOSCache is in options
      const index = osOptions.findIndex((option) => option.id === selectedOSCache?.id);
      if (index === -1) {
        // if not, set selectedOS to first option and selectedOSCache to first option
        const newOS = osOptions[0];
        setSelectedOS(newOS);
        setSelectedOSCache(newOS);
      } else {
        // if it is, set selectedOS to selectedOSCache
        setSelectedOS(selectedOSCache);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [osOptions, selectedOSCache]);

  const handleOsChange = (os) => {
    const selectedOsOption = osOptions.find((option) => option.id === os.id);
    const newOS = selectedOsOption || osOptions[0];
    setSelectedOS(newOS);
    setSelectedOSCache(newOS);
  };

  return {handleOsChange, osOptions, selectedOS};
};
